import { render, staticRenderFns } from "./PackagesTypeList.vue?vue&type=template&id=914ab9f2&scoped=true"
import script from "./PackagesTypeList.vue?vue&type=script&lang=js"
export * from "./PackagesTypeList.vue?vue&type=script&lang=js"
import style0 from "./PackagesTypeList.vue?vue&type=style&index=0&id=914ab9f2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "914ab9f2",
  null
  
)

export default component.exports